<nav #navbar *ngIf="userName" myHideGlobalNav
     class="navbar navbar-expand-sm navbar-default{{isImpersonating ? ' impersonating' : ''}}">
    <div class="container-fluid">
        <div class="navbar-header">
            <a class="navbar-brand" routerLink="/"></a>
        </div>
        <div class="collapse navbar-collapse">
            <ul class="nav navbar-nav" *ngIf="!tooSmall; else hamburger">
                <li class="facilities">
                    <my-global-facility-selector></my-global-facility-selector>
                </li>
                <li class="hide-small {{isDON || isCorporate ? 'home-link' : 'menu-link'}}" *ngIf="isDON || isCorporate">
                    <a routerLink="/home/dashboard"
                       routerLinkActive="active"
                    >Home</a>
                </li>
                <li class="hide-small {{isDON || isCorporate? 'menu-link' : 'home-link'}}" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                    <a routerLink="/alerts"
                       routerLinkActive="active"
                    >Alerts</a>
                </li>
                <li class="hide-small menu-link" *ngIf="isDON || isCorporate || isNurse">
                    <a routerLink="/search/medication-search"  
                        routerLinkActive="active"             
                    >Med Search</a>
                </li>
                <li class="hide-small menu-link" *ngIf="isDON || isCorporate || isNurse">
                    <a routerLink="/residents"
                       routerLinkActive="active"                      
                    >Residents</a>
                </li>
                <li class="dropdown dropdown-hover menu-link" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                    <a routerLink="/home/orders"
                       routerLinkActive="active"
                    >Orders
                    </a>
                </li>
                <li class="dropdown dropdown-hover menu-link" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                    <a routerLink="/reports"
                       routerLinkActive="active"
                    >Reports</a>
                </li>
                <li class="dropdown dropdown-hover menu-link">
                    <a routerLink="/resources"
                       routerLinkActive="active"
                    >Resources</a>
                  </li>
            </ul>
            <ul class="nav navbar-nav {{tooSmall ? '' : 'navbar-right'}}">
                <li dropdown class="dropdown bookmark" *ngIf="isDev">
                    <a dropdownToggle class="dropdown-link icon">
                        <img src="assets/img/icon-nav-bookmarks.png">
                    </a>
                    <ul *dropdownMenu role="menu" class="bookmark-dropdown dropdown-menu">
                        <li class="dropdown-header">Bookmarks</li>
                        <li role="menuitem">
                            <a class="dropdown-item"
                               href="#"
                            >Report Title</a></li>
                        <li class="divider dropdown-divider"></li>
                        <li role="menuitem">
                            <a class="dropdown-item"
                               href="#"
                            >Very Long Report Title Very Long Report
                                Title</a></li>
                        <li class="divider dropdown-divider"></li>
                        <li role="menuitem">
                            <a class="dropdown-item"
                               href="#"
                            >Report Title</a></li>
                        <li class="divider dropdown-divider"></li>
                        <li role="menuitem">
                            <a class="dropdown-item"
                               href="#"
                            >Report Title</a></li>
                    </ul>
                </li>
                <li class="chat" *ngIf="isDev">
                    <a  class="icon"><img src="assets/img/icon-nav-chat.png"></a>
                </li>
                <li dropdown class="dropdown counter" *ngIf="isDev">
                    <a  dropdownToggle class="dropdown-link icon">
                        <div class="counter">2</div>
                    </a>
                    <ul *dropdownMenu role="menu" class="counter-dropdown dropdown-menu">
                        <li class="dropdown-header">Unread Notifications</li>
                        <li role="menuitem">
                            <input type="search" placeholder="Search">
                        </li>
                        <li role="menuitem"><a class="dropdown-item" href="#">Select all facilities</a></li>
                        <li role="menuitem">
                            <div>
                                <a class="dropdown-item"
                                   href="#"
                                >Another action</a></div>
                            <div>
                                <a class="dropdown-item"
                                   href="#"
                                >Another action</a></div>
                        </li>
                    </ul>
                </li>
                <li class="btn-group" dropdown class="dropdown profile">
                    <div class="spacer"></div>
                    <a dropdownToggle class="no-hover dropdown-link">
                            <div class="profile-icon">{{userAvatar}}</div>
                            <span class="name">{{userName}}</span> <span class="caret profile-caret"></span>
                            <div class="wing" *ngIf="isNurse && isDev">East Wing</div>
                    </a>
                    <ul *dropdownMenu role="menu" class="profile-dropdown dropdown-menu">
                        <li role="menuitem">
                            <a class="dropdown-item"
                               routerLink="/profile"
                            >My Profile</a></li>
                        <li class="divider dropdown-divider"></li>
                        <li role="menuitem" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                            <a class="dropdown-item"
                               routerLink="/profile/notifications"
                            >Notification Settings</a></li>
                        <li class="divider dropdown-divider" *ngIf="isNurse && isDev"></li>
                        <li role="menuitem" *ngIf="isNurse && isDev">
                            <a class="dropdown-item"
                               href="#"
                            >My Care Coverage</a>
                            <div class="wing selection" *ngIf="isDev">
                                <label class="checkbox"><input type="checkbox">
                                    <span></span><div class="wing-section">East Wing</div>
                                </label>
                            </div>
                        </li>
                        <li class="divider dropdown-divider" ></li>
                        <li role="menuitem" *ngIf ="isUserAdmin">
                            <a class="dropdown-item"
                               routerLink="/admin-tools"
                            >Administrator Tools</a></li>
                        <li class="divider dropdown-divider"></li>
                        <li role="menuitem">
                            <a class="dropdown-item" (click)="hideScreenModal.show()">Hide Screen</a>
                        </li>
                        <li role="menuitem">
                            <a class="dropdown-item" [routerLink]="['/login',{'logout':true}]">Log Out</a>
                        </li>
                    </ul>

                </li>
            </ul>
            <ng-template #hamburger>
                <ul class="nav navbar-expand-sm navbar-nav">
                    <li class="facilities">
                        <my-global-facility-selector></my-global-facility-selector>
                    </li>
                    <li class="btn-group" dropdown class="dropdown profile">
                        <a dropdownToggle class="dropdown-link no-hover" style="text-transform: uppercase">
                            {{selectedRoute}} <span class="caret profile-caret"></span>
                        </a>
                        <ul *dropdownMenu role="menu" class="profile-dropdown-small dropdown-menu">
                            <li role="menuitem" *ngIf="isDON || isCorporate">
                                <a class="dropdown-item" routerLink="/home/dashboard"
                                   routerLinkActive="active-small">Home</a>
                            </li>
                            <li class="divider dropdown-divider"></li>

                            <li role="menuitem" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                                <a class="dropdown-item" routerLink="/alerts"
                                   routerLinkActive="active-small">Alerts</a>
                            </li>
                            <li class="divider dropdown-divider"></li>

                            <li role="menuitem" *ngIf="isDON || isCorporate || isNurse">
                                <a class="dropdown-item" routerLink="/residents"
                                   routerLinkActive="active-small">Residents</a>
                            </li>
                            <li class="divider dropdown-divider"></li>

                            <li role="menuitem" *ngIf="isDON || isCorporate || isNurse">
                                <a class="dropdown-item" routerLink="/home/orders"
                                   routerLinkActive="active-small">Orders</a>
                            </li>
                            <li class="divider dropdown-divider"></li>

                            <li role="menuitem" *ngIf="isDON || isCorporate || isNurse || isBusinessOffice">
                                <a class="dropdown-item" routerLink="/reports"
                                   routerLinkActive="active-small">Reports</a>

                            </li>
                            <li class="divider dropdown-divider"></li>

                            <li role="menuitem">
                                <a class="dropdown-item" routerLink="/resources"
                                   routerLinkActive="active-small">Resources</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </ng-template>
        </div>
    </div>
</nav>

<!-- Hide Screen Modal -->
<div class="modal fade" bsModal #hideScreenModal="bs-modal" id="hideScreenModal"
     [config]="{backdrop: 'static', keyboard: true}" (click)="hideScreenModal.hide()"
     tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body text-center">
                <img src="assets/img/my-remedi-logo-login.png" height="64" width="356">
            </div>
            <div class="modal-footer">
                <div class="text-center">
                    <u>Click</u> or press <kbd>ESC</kbd> to view screen.
                </div>
            </div>
        </div>
    </div>
</div>
